<template>
    <div class="project-twelve">
        <div class="project-twelve__title">
            <h1><span>Project</span><span>Twelve</span></h1>
        </div>
        <div class="divider"></div>
        <learn-button></learn-button>
        <div class="social">
            <div class="twitter">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 6.08407C30.8232 6.60524 29.5591 6.95738 28.2301 7.11655C29.6013 6.29648 30.6272 5.00577 31.1164 3.48528C29.828 4.25011 28.418 4.78847 26.9476 5.07695C25.9588 4.02175 24.6491 3.32234 23.2218 3.08732C21.7945 2.8523 20.3296 3.09481 19.0543 3.7772C17.7791 4.4596 16.7649 5.5437 16.1693 6.86118C15.5737 8.17867 15.43 9.65584 15.7604 11.0633C13.1499 10.9323 10.5961 10.2542 8.26485 9.07291C5.93354 7.89163 3.87681 6.23361 2.22813 4.20646C1.66441 5.17837 1.34026 6.30522 1.34026 7.50532C1.33963 8.58568 1.60582 9.64949 2.11522 10.6024C2.62461 11.5552 3.36145 12.3677 4.26037 12.9677C3.21787 12.9346 2.19836 12.653 1.28671 12.1465V12.231C1.2866 13.7463 1.81102 15.2149 2.77098 16.3877C3.73094 17.5605 5.06731 18.3652 6.55333 18.6654C5.58624 18.927 4.57231 18.9655 3.58813 18.778C4.0074 20.0818 4.82409 21.2219 5.92389 22.0388C7.02368 22.8556 8.35151 23.3082 9.72148 23.3333C7.39587 25.158 4.52376 26.1478 1.56716 26.1434C1.04343 26.1436 0.520146 26.113 0 26.0519C3.00111 27.9804 6.49462 29.004 10.0625 29C22.1404 29 28.7431 19.002 28.7431 10.3309C28.7431 10.0492 28.736 9.76465 28.7233 9.48294C30.0076 8.55466 31.1162 7.40516 31.9972 6.0883L32 6.08407V6.08407Z" fill="currentColor"/>
                </svg>
            </div>
            <div class="telegram">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28.9076 2.17753L1.44751 13.1744C-0.426527 13.9561 -0.415685 15.0418 1.10368 15.526L8.15377 17.81L24.4656 7.12188C25.2369 6.63452 25.9416 6.8967 25.3624 7.4307L12.1465 19.8173H12.1434L12.1465 19.8189L11.6602 27.3657C12.3727 27.3657 12.6871 27.0263 13.0867 26.6258L16.511 23.1677L23.6339 28.6316C24.9473 29.3827 25.8905 28.9967 26.2173 27.3689L30.8931 4.48404C31.3717 2.49118 30.1605 1.58884 28.9076 2.17753V2.17753Z" fill="currentColor"/>
                </svg>
            </div>
            <div class="discord">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.413 6.91825C24.4456 6.01035 22.3642 5.36525 20.2239 5C19.9573 5.47537 19.6458 6.11475 19.431 6.62341C17.1234 6.28118 14.8369 6.28118 12.5717 6.62341C12.357 6.11486 12.0385 5.47537 11.7694 5C9.62699 5.36542 7.54382 6.01216 5.57547 6.92298C1.6586 12.7607 0.596759 18.4533 1.12762 24.0653C3.72555 25.9787 6.2432 27.141 8.71844 27.9016C9.3336 27.0673 9.87738 26.184 10.3442 25.2608C9.45546 24.9271 8.59871 24.5159 7.7841 24.032C7.99847 23.8753 8.2078 23.712 8.41176 23.5423C13.3479 25.8194 18.7114 25.8194 23.5887 23.5423C23.7936 23.7108 24.0028 23.8741 24.2163 24.032C23.4003 24.5171 22.542 24.9292 21.6515 25.2632C22.1209 26.1902 22.6638 27.0743 23.2772 27.904C25.7548 27.1435 28.2748 25.9811 30.8727 24.0653C31.4957 17.5596 29.8087 11.9192 26.413 6.91813V6.91825ZM11.0167 20.614C9.53488 20.614 8.31965 19.2496 8.31965 17.5882C8.31965 15.9267 9.50899 14.56 11.0167 14.56C12.5246 14.56 13.7397 15.9243 13.7138 17.5882C13.7161 19.2496 12.5246 20.614 11.0167 20.614ZM20.9836 20.614C19.5018 20.614 18.2867 19.2496 18.2867 17.5882C18.2867 15.9267 19.4759 14.56 20.9836 14.56C22.4915 14.56 23.7066 15.9243 23.6807 17.5882C23.6807 19.2496 22.4915 20.614 20.9836 20.614V20.614Z" fill="currentColor"/>
                </svg>
            </div>
        </div>
        <div class="message">
            <div class="vertical-divider"></div>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
        </div>
        <canvas ref="canvas" class="project-twelve__background"></canvas>
    </div>
</template>

<script>
import learnButton from '../components/learnButton.vue'
import { fluidSimulation } from '../scripts/fluidSimulation.js'
export default {
    name: 'projectTwelveScreen',

    components: {
        learnButton
    },

    mounted() {
        fluidSimulation(this.$refs.canvas)
    },

    data() {
        return {
        }
    },
}
</script>

<style lang='scss'>
    .project-twelve {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        @media screen and (max-width: point(sm)) {
            align-items: center;
            justify-content: flex-start;
            padding-top: 2rem !important;
        }

        .project-twelve__title {
            position: relative;
            z-index: 1;
            pointer-events: none;

            @media screen and (max-width: point(sm)) {
                margin-top: 15vh;
            }

            &:before, &:after {
                content: '';
                display: block;
                position: absolute;
                border-radius: 50%;
                background: rgba(color('white'), 1%);
                backdrop-filter: blur(24px);
                width: var(--width);
                height: var(--height);

                @media screen and (max-width: point(sm)) {
                    backdrop-filter: blur(8px);
                }
            }

            &:before {
                --width: 6.125rem;
                --height: var(--width);
                top: calc(var(--width) / -3);
                left: calc(var(--height) / -2);
                box-shadow: inset 0px -.5rem .875rem rgba(color('white'), 25%);
                z-index: -1;

                @media screen and (max-width: point(sm)) {
                    --width: 2.3125rem;
                }
            }

            &:after {
                --width: 9.25rem;
                --height: var(--width);
                right: 0;
                bottom: calc(var(--height) / -3);
                box-shadow: inset 0px 4px 4px rgba(color('white'), 25%);
                z-index: 3;

                @media screen and (max-width: point(sm)) {
                    --width: 3.375rem;
                }
            }
        }

        h1 {
            @include font-azonix;
            font-size: font(144);
            text-transform: uppercase;
            line-height: 9.5rem;
            text-align: left;
            z-index: 1;
            display: flex;
            flex-direction: column;

            @media screen and (max-width: point(sm)) {
                font-size: font(61);
                line-height: 4rem;
                text-align: center;
            }
        }

        .divider {
            --divider-width: 6.125rem;
            width: var(--divider-width);
            height: 4px;
            background: color('white');
            margin-top: 1.8125rem;
            z-index: 1;

            @media screen and (max-width: point(sm)) {
                margin-top: 3.125rem;
            }
        }

        .learn-button {
            margin-top: 2rem;
            z-index: 1;

            @media screen and (max-width: point(sm)) {
                margin-top: 3.125rem;
            }
        }
    }

    .project-twelve .social {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 50%; right: 4rem;
        transform: translate3d(0, -50%, 0);
        color: color('blue-light');
        z-index: 1;

        @media screen and (max-width: point(sm)) {
            display: none;
        }

        > div {
            width: 1.5rem;
            height: 1.5rem;
            cursor: pointer;

            &:not(:first-child) {
                margin-top: 2rem;
            }

            svg {
                width: 100%;
                height: 100%;
                min-width: 100%;
                min-height: 100%;
            }
        }
    }

    .project-twelve .message {
        position: absolute;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        right: 4rem;
        bottom: 4rem;
        z-index: 1;
        pointer-events: none;

        @media screen and (max-width: point(sm)) {
            right: auto;
            left: 2rem;

            @media screen and (min-aspect-ratio: 480 / 720) {
                display: none;
            }
        }

        .vertical-divider {
            width: 4px;
            height: auto;
            background: color('white');
            margin-right: 1.5rem;
            pointer-events: none;
        }

        p {
            @include font-light;
            font-size: font(16);
            line-height: 1.375rem;
            max-width: 21.8125rem;
            text-align: left;

            @media screen and (max-width: point(sm)) {
                max-width: calc(100% - 4rem);
            }
        }
    }

    .project-twelve__background {
        position: absolute;
        width: 100%;
        height: 200%;
        left: 0; top: 0;
        z-index: 0;
    }

    // animation styles before
    .project-twelve {
        h1 {
            opacity: 0;
            transition: opacity var(--content-appear-time);
            span:first-child {
                transform: translate3d(15rem, 0, 0);
                transition: transform var(--content-appear-time) ease;
            }
            span:last-child {
                transform: translate3d(25rem, 0, 0);
                transition: transform var(--content-appear-time) ease;
            }
        }
        .divider {
            max-width: 0;
            transition: max-width var(--content-appear-time) ease;
        }
        .message {
            .vertical-divider {
                max-height: 0;
                transition: var(--content-appear-time) max-height .3s ease;
            }
            p {
                transform: translate3d(0, 5rem, 0);
                opacity: 0;
                transition: var(--content-appear-time) transform .3s ease, var(--content-appear-time) opacity .5s;
            }
        }
    }
    // animation styles after
    .project-twelve.active {
        h1 {
            opacity: 1;
            span:first-child {
                transform: translate3d(0, 0, 0);
            }
            span:last-child {
                transform: translate3d(0, 0, 0);
            }
        }
        .divider {
            max-width: var(--divider-width);
        }
        .message {
            .vertical-divider {
                max-height: 15rem;
            }

            p {
                transform: translate3d(0, 0, 0);
                opacity: 1;
            }
        }
    }
</style>
